import { render, staticRenderFns } from "./ProductCustomers.vue?vue&type=template&id=6de77156&"
import script from "./ProductCustomers.vue?vue&type=script&lang=js&"
export * from "./ProductCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomers.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de77156')) {
      api.createRecord('6de77156', component.options)
    } else {
      api.reload('6de77156', component.options)
    }
    module.hot.accept("./ProductCustomers.vue?vue&type=template&id=6de77156&", function () {
      api.rerender('6de77156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductCustomers.vue"
export default component.exports